import React from 'react';
import { css } from '@emotion/css';
import Container from 'evcharging/components/Container';
import { Theme } from 'evcharging/app/themes';
import useTheme from 'evcharging/hooks/useTheme';
import Paragraph from 'evcharging/components/Paragraph';
import header from 'assets/about-us/header.png';
import useI18n from 'evcharging/hooks/useI18n';

const AboutUsHeader = () => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const { t } = useI18n();

  return (
    <header className={styles.root}>
      <Container>
        <div className={styles.content}>
          {/*<h1 className={styles.title}>{t('about-us.welcome-to')}</h1>*/}
          {/*<Spacer value={20} />*/}
          <div className={styles.text} color={'light'}>
            {t('about-us.unlock-the')}
          </div>
        </div>
      </Container>
    </header>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    background-image: url(${header});
    background-repeat: no-repeat;
    background-size: cover;
      background-position: center center;
    color: #fff;
    margin-top: 98px;
    ${theme.breakpoints.mobile.down} {
      margin-top: 68px;
    }
  `,
  title: css`
    font-weight: 900;
    font-size: 64px;
    line-height: 78px;
    color: #F9C106;
    max-width: 735px;
    ${theme.breakpoints.mobile.down} {
      font-size: 32px;
      line-height: 40px;
    }
  `,
  content: css`
      padding: 50px 0 45px;
      min-height: 534px;
      display: flex;
      justify-content: center;
      align-items: center;
      ${theme.breakpoints.mobile.down} {
          padding: 50px 0 45px;
      }
  `,
  text: css`
    text-align: center;
      max-width: 941px;
      font-size: 24px;
      font-weight: 600;
      ${theme.breakpoints.mobile.down} {
          font-size: 16px;
      }
  `,
});

export default AboutUsHeader;
